import { BrowserRouter as Router, Route, Switch, Link,Redirect } from "react-router-dom";
import logo from './logo.svg';
import './App.css';
import UserSession from './user-session/UserSession';
import JoinMeetingComponent from "./user-session/sessionPages/joinMeeting/JoinMeeting";
import MeetingV1Component from "./user-session/sessionPages/userMeeting/MeetingV1";
import PublicUserSessionComponent from "./user-session/PublicUserSession";
import PublicInspireBot from "./user-session/pptDesigners/publicInspireBot";
import PublicInspireBotAddOn from "./user-session/pptDesigners/publicInspireBotAddOn";


function App() {
  return (
    <div className="App">
        <Router>
          <Switch>
            <Route path="/joinMeeting/:meetingId"  
                        component={JoinMeetingComponent}
              />
            <Route exact path="/login"  
                        component={UserSession}
                />
              <Route exact path="/inspireBot"  
                        component={PublicInspireBot}
                />
            <Route exact path="/inspireBotAddOn"  
                        component={PublicInspireBotAddOn}
                />

              <Route exact path="/"  
                        component={PublicUserSessionComponent}
                />
            <Redirect from="*" to="/" />
          </Switch>
        </Router>
    </div>
  );
}

export default App;
